<ng-container wp-isolated-query-space>
  <wp-embedded-table #embeddedTableForConfiguration
    [queryProps]="queryProps"
    [configuration]="{ tableVisible: false }">
  </wp-embedded-table>
</ng-container>
